import { CellGroup, Cell, Popup, Field, Button, picker, Tag } from 'vant'
import Bussiness from 'Utils/business'
import { formatDate } from 'Utils/dateUtil'
import { mapGetters } from 'vuex'
import ldUploader from 'Components/ldUploader'

export default {
  name:'HtOrderDetail',
  provide: {
    orderType: $dict.ORDER_TYPE.hotel.normal
  },
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [picker.name]: picker,
    travelInfo: () => import('Components/travelInfo'),
    ldEmailPopup: () => import('Components/LdEmailPopup'),
    ldTabbar: () => import('Components/ldTabbar/ldTabbar'),
    approval: () => import('Components/approval/approval'),
    // ldPay: () => import('Components/ldPay/index.vue'),
    Bussiness,
    ldButton: () => import('Common/ldButton'),
    /**
     * 信用卡担保组件
     */
    HtCreditCard: () => import('Views/Ht/htQuery/htCreditCard/index.vue'),
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldUploader
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isShowGuarantee: {
      type: String,
      default: ''
    },
    isLdentifying:''
  },
  data() {
    return {
      mescroll: null, // mescroll实例对象
      detail: {}, // 正常单详情
      isCreditCard: false,
      priceList: [],
      mescrollDown: {
        callback: this.loadData,
      },
      showPicker: false,
      columns: [
        {
          text: '身份证',
          value: 1
        },
        {
          text: '护照',
          value: 2
        },
        {
          text: '军人证',
          value: 3
        },
        {
          text: '其他',
          value: 4
        }
      ],
      pickerData: {},
      emailPopup:false
    }
  },
  computed: {
    ...mapGetters({
      sysType:'sysType'
    })
  },
  created() {
    this.loadData()
  },
  methods: {
    mescrollInit (mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    loadData() {
      this.$api['htQuery/hotelOrderDetail']({
        orderId: this.id
      }).then(res => {
        this.detail = res.data
        if(this.isLdentifying && this.detail.orderStatus !='5'){
          let index =  res.data.orderStatusRemark.indexOf('|')
          this.detail.orderStatusRemark  = res.data.orderStatusRemark.substr(0, index+1)+'确认中';
        }
        this.detail.orderType = $dict.ORDER_TYPE.hotel.normal
        this.detail._rzrqweek = formatDate(this.detail.rzrq).week
        this.detail._ldrqweek = formatDate(this.detail.ldrq).week
        this.detail._violation = {
          reasonCode: res.data.reasonCode,
          reasonDesc: res.data.reasonDesc,
          violateitem: res.data.violateitem
        }
        /**
         * 构建明细面板
         */
        this.structureDetailed()
        this.$nextTick(() => { // 数据渲染成功后,隐藏下拉刷新的状态
          this.mescroll.endSuccess()
        })
        /**
				 * 国际酒店暂无违背信息
				 */
        if (this.detail.international == 0) this.detail.violateitem = null
      }).catch(() => {})
    },
    /**
     * 送审/再次送审
     */
    approval() {
      Bussiness.ApprovalSend(this.detail)
    },
    async revertApproval () {
      await Bussiness.ApprovalRevert(this.detail)
      this.loadData()
    },
    /**
     * 退房
     */
    refund() {
      this.$router.push({ path: '/ht/htOrder/htRefund/' + this.id + ''}) 
    },
    /**
     * 取消
     */
    cancel() {
      this.$dialog.confirm({
        message:'是否取消订单'
      }).then(() => {
        this.$api['htQuery/hotelOrderCancel']({
          orderFrom: this.sysType,
          orderId: this.detail.orderId
        }).then(()=>{
          this.loadData()
        })
      })
    },
    /**
     * 信用卡担保回调
     */
    listenChildCreditCard(data) {
      this.isCreditCard = false
      this.$api['htQuery/editCreditcard']({
        'orderId': this.detail.orderId, // 订单ID,如果表中存在该记录则修改，否则添加
        'cardType': data.cardType, // 
        'number': data.number, // 卡号；若需要修改则传入,无需加密,后台处理
        'cvv': data.CVV, // cvv；若需要修改则传入,无需加密,后台处理
        'expirationYear': data.expirationYear, // 有效期-年 yyyy；若需要修改则传入
        'expirationMonth': data.expirationMonth, // 有效期-月 mm；若需要修改则传入
        'holderName': data.holderName, // 持卡人；若需要修改则传入
        'idType': data.idType, // 证件类型。身份证 1， 护照 2，军人证 3， 其他 4；若需要修改则传入
        'idNo': data.idNo, // 证件号码；若需要修改则传入,无需加密,后台处理
        'tel': data.tel, // 持卡人手机；若需要修改则传入
        'dbJe': this.detail.dbJe // 担保金额
      }).then(()=>{
        this.$toast('担保信息修改成功！')
      })
    },
    structureDetailed() {
      /**
             * 初始化 this.priceList
             */
      this.priceList = []
      /**
             * 到店付 && 需要担保的 需要在明细面板中展示[在线担保金额]
             */
      if (this.detail.zflx == '1' && this.detail.sfxfdb == '1') {
        this.priceList.push({
          name: '在线担保',
          price: this.detail.dbJe,
          amount: this.detail.rooms,
          unit: '间'
        })
      }
      /**
             * priceAfterTax 供应商税后价格（成本价）没值
             */
      this.detail.roomList[0].everyPriceList.forEach(element => {
        this.priceList.push({
          name: element.day,
          price: element.xsj,
          amount: this.detail.rooms,
          unit: '间'
        })
      })
      this.priceList.push({
        name: '服务费',
        price: this.detail.chargeunit  == '1' ? (this.detail.fwf / Number(this.detail.rooms)) : this.detail.fwf,
        amount: this.detail.chargeunit  == '1' ? this.detail.rooms : '',
        unit: this.detail.chargeunit == '1' ? '间' : ''
      })
    },
    showPickerMethod() {
      this.showPicker = true
    },
    onConfirm(value) {
      this.pickerData = {
        _typeName: value.text,
        idType: value.value,
      }
      this.showPicker = false
    },
    pay(){
      this.$router.push({path:'/pay/payment',query:{orderType:this.detail.orderType,orderId:this.detail.orderId}})
    },
  }
}